import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Company } from '@models/companies/company';
import { Document } from '@models/documents/document';
import { EntityChangeData } from '@models/documents/entity-change-data';
import { CompanyChangeData } from '@models/ui-models/company-change-data';
import { CompanySubtype, CompanyType } from '@models/companies/company-enums';
import { SelectOption } from '@models/ui-models/select-options';
import { ChangeDictionaryHelper } from '@models/ui-models/change-dictionary-helper.model';
import { CompanyChangeTypeComponent } from '../../asic-forms/company';

export enum ChangeCompanyTypeStepsEnum {
  FormDescription = 0,
  ChangeOfType = 1,
}

export const companyTypeOptions: SelectOption[] = [
  { value: 1, label: 'Proprietary company limited by shares' },
  { value: 2, label: 'Unlimited proprietary company' },
  { value: 3, label: 'Public company limited by shares' },
  { value: 4, label: 'Company limited by guarantee' },
  { value: 5, label: 'Unlimited public company' },
  { value: 6, label: 'Public no liability company' },
  { value: 7, label: 'Company limited by both shares and guarantee' },
];

export const companySubtypeDictionaryOptions: Record<number, SelectOption[]> = {
  [1]: [
    { value: 2, label: 'Unlimited proprietary company' },
    { value: 4, label: 'Unlimited public company' },
    { value: 3, label: 'Public company limited by shares' },
  ],
  [2]: [
    { value: 1, label: 'Proprietary company limited by shares' },
    { value: 3, label: 'Public company limited by shares' },
    { value: 4, label: 'Unlimited public company' },
  ],
  [3]: [
    { value: 4, label: 'Unlimited public company' },
    { value: 2, label: 'Unlimited proprietary company' },
    { value: 1, label: 'Proprietary company limited by shares' },
    { value: 6, label: 'Public no liability company' },
  ],
  [4]: [
    { value: 3, label: 'Public company limited by shares' },
    { value: 4, label: 'Unlimited public company' },
    { value: 1, label: 'Proprietary company limited by shares' },
    { value: 2, label: 'Unlimited proprietary company' },
  ],
  [5]: [
    { value: 3, label: 'Public company limited by shares' },
    { value: 1, label: 'Proprietary company limited by shares' },
    { value: 2, label: 'Unlimited proprietary company' },
  ],
  [6]: [
    { value: 3, label: 'Public company limited by shares' },
    { value: 1, label: 'Proprietary company limited by shares' },
  ],
  [7]: [
    { value: 1, label: 'Proprietary company limited by shares' },
    { value: 3, label: 'Public company limited by shares' },
    { value: 4, label: 'Company limited by guarantee' },
  ],
};

export class CompanyChangeType extends EntityChangeData {
  static override readonly $type = 'CompanyChangeType';
  companyType: CompanyType;
  companySubtype: CompanySubtype;

  constructor(data: Partial<CompanyChangeType> = {}) {
    super(data);

    // TODO: Add ChangeType
    this.changeType = 'c:206';
    this.companyType = data.companyType!;
    this.companySubtype = data.companySubtype!;
  }

  override toDictionary(): { key: string; value: string; }[] {
    const dict = new ChangeDictionaryHelper();

    dict
      .add('Date of Change', this.changeDate)
      .add('Company Type', CompanyType[this.companyType])
      .add('Company Subtype', CompanySubtype[this.companySubtype])

    return dict.dictionary;
  }

  override fillModal(modalRef: NgbModalRef, document: Document, actualCompany: Company): NgbModalRef {
    modalRef = this.fillModalWithCompany(modalRef, actualCompany, true);
    (modalRef.componentInstance as CompanyChangeTypeComponent).companyChangeData.documentId = document.documentId;
    return modalRef;
  }

  override fillModalWithCompany(modalRef: NgbModalRef, company: Company, isEdit: boolean): NgbModalRef {
    const instance = modalRef.componentInstance as CompanyChangeTypeComponent;

    instance.isEdit = isEdit;
    instance.companyChangeData = new CompanyChangeData(company);
    instance.formModel = structuredClone(this);

    return modalRef;
  }
}
